export default (props, vars) => !!props?.['companyLogo'];
